module.exports = __webpack_public_path__ + "580cca37229d653bc13fe09bd286d05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/CancellationPolicy/cancle-policy-change.png
// module id = 1302
// module chunks = 47